import {Image} from '@primer/react-brand'

interface Props {
  visual: string
}

export function SectionVisual({visual}: Props) {
  return (
    <div className="SectionVisual">
      {/* WebGL */}
      <div className="SectionVisual-webgl" />

      {/* Static fallback */}
      <Image
        className="SectionVisual-static"
        src={`/images/modules/site/home24/section-visual-${visual}.webp`}
        alt=""
      />
    </div>
  )
}

try{ SectionVisual.displayName ||= 'SectionVisual' } catch {}